<template>
	<svg
		width="80"
		height="40"
		viewBox="0 0 120 100"
		xmlns="http://www.w3.org/2000/svg"
		fill="#ecd9ff"
	>
		<!-- Bar 1 -->
		<rect
			x="10"
			:y="isSpeaking ? '40' : '40'"
			width="15"
			:height="isSpeaking ? '15' : '15'"
			rx="7.5"
			:style="!isSpeaking ? 'transition: all 0.4s ease; height: 20px; y: 40px;' : ''"
		>
			<animate
				v-if="isSpeaking"
				attributeName="height"
				values="20;60;20"
				dur="1s"
				repeatCount="indefinite"
			/>
			<animate
				v-if="isSpeaking"
				attributeName="y"
				values="40;20;40"
				dur="1s"
				repeatCount="indefinite"
			/>
		</rect>

		<!-- Bar 2 -->
		<rect
			x="40"
			:y="isSpeaking ? '30' : '30'"
			width="15"
			:height="isSpeaking ? '35' : '35'"
			rx="7.5"
			:style="!isSpeaking ? 'transition: all 0.4s ease; height: 40px; y: 30px;' : ''"
		>
			<animate
				v-if="isSpeaking"
				attributeName="height"
				values="40;80;40"
				dur="1s"
				begin="0.1s"
				repeatCount="indefinite"
			/>
			<animate
				v-if="isSpeaking"
				attributeName="y"
				values="30;10;30"
				dur="1s"
				begin="0.1s"
				repeatCount="indefinite"
			/>
		</rect>

		<!-- Bar 3 -->
		<rect
			x="70"
			:y="isSpeaking ? '30' : '30'"
			width="15"
			:height="isSpeaking ? '35' : '35'"
			rx="7.5"
			:style="!isSpeaking ? 'transition: all 0.4s ease; height: 40px; y: 30px;' : ''"
		>
			<animate
				v-if="isSpeaking"
				attributeName="height"
				values="40;80;40"
				dur="1s"
				begin="0.2s"
				repeatCount="indefinite"
			/>
			<animate
				v-if="isSpeaking"
				attributeName="y"
				values="30;10;30"
				dur="1s"
				begin="0.2s"
				repeatCount="indefinite"
			/>
		</rect>

		<!-- Bar 4 -->
		<rect
			x="100"
			:y="isSpeaking ? '40' : '40'"
			width="15"
			:height="isSpeaking ? '15' : '15'"
			rx="7.5"
			:style="!isSpeaking ? 'transition: all 0.4s ease; height: 20px; y: 40px;' : ''"
		>
			<animate
				v-if="isSpeaking"
				attributeName="height"
				values="20;60;20"
				dur="1s"
				begin="0.3s"
				repeatCount="indefinite"
			/>
			<animate
				v-if="isSpeaking"
				attributeName="y"
				values="40;20;40"
				dur="1s"
				begin="0.3s"
				repeatCount="indefinite"
			/>
		</rect>
	</svg>
</template>

<script setup>
import { defineProps } from "vue";
const props = defineProps({
	isSpeaking: Boolean,
	color: {
		type: String,
		default: "#ecd9ff",
	},
});

const bars = Array.from({ length: 5 });
</script>

<style scoped>
.wave-wrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 40px;
	width: auto;
	overflow: hidden;
}

.wave-container {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 6px;
	height: 100%;
}

.wave-bar {
	width: 6px;
	height: 20px;
	border-radius: 3px;
	transform-origin: center center;
	transition: height 0.4s ease, transform 0.4s ease;
}

/* Quando parlano, le barre si animano */
.is-animating {
	animation: waveMove 1.2s ease-in-out infinite;
}

/* Le barre si alzano e abbassano intorno al centro */
@keyframes waveMove {
	0%,
	100% {
		transform: scaleY(1);
	}
	50% {
		transform: scaleY(2.2);
	}
}
</style>
